import { ColDef, ColGroupDef } from '@ag-grid-community/core';

import { ZERO_HYPHEN } from '@shared/constants/format';
import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';

import {
  defaultHeaderClass,
  defaultMinWidth,
  InMonthAdjustmentGridConfigContext,
} from './ima-grid-config-context';
import { ImaTableGroups } from '../enum/ima-table-gropes';

export const imaCategoryColumnGroup = (ctx: InMonthAdjustmentGridConfigContext): ColGroupDef => {
  const { gridData } = ctx;
  const children: ColDef[] = [];

  const groups = {
    group0: false,
    group1: false,
    group2: false,
    group3: false,
    group4: false,
  };

  gridData.forEach((row) => {
    Object.keys(groups).forEach((_key) => {
      const key = _key as keyof typeof groups;

      if (row[key]) {
        groups[key] = true;
      }
    });
  });

  Object.entries(groups).forEach(([key, value], index) => {
    if (value) {
      const headerName = `Category ${index + 1}`;

      children.push({
        cellClass: getCellClassForGroups,
        field: key,
        headerClass: defaultHeaderClass,
        headerName,
        headerTooltip: headerName,
        minWidth: defaultMinWidth,
        valueFormatter: (params) => params.value || ZERO_HYPHEN,
        width: 135,
      });
    }
  });

  return {
    children,
    groupId: ImaTableGroups.CATEGORY,
    headerClass: ['text-center', 'header-marker'],
    headerName: 'Category',
    suppressStickyLabel: true,
  };
};
